import React, { useEffect, useState } from 'react';
import './css/style.scss';
import WidgetTile from '../../../components/widgetTile';
import AlertCriticalityCard from './alertCriticalityCard';
import { getAnomalyList } from '../../../services/anomalyService';

const WidgetAlerts = () => {
  const [alerts, setAlerts] = useState([]);
  const [filterChecked, setFilterChecked] = useState({});
  const [loading, setLoading] = useState(true);

  const selection = JSON.parse(sessionStorage.getItem('xalert-filter'));
  let default_selection = {
    data: {},
    selection: {
      usecase: [{ label: 'pharma', value: 'pharma' }]
    },
    selection_values: {
      usecase: ['pharma']
    }
  };
  const [filters, setFilters] = useState(selection || default_selection);

  useEffect(() => {
    initializeChecked();
    fetchAlerts();
  }, []);

  // ✅ Fetch backend alerts
  const fetchAlerts = async () => {
    try {
      const response = await getAnomalyList(alerts.length, 5, {
        ...filters.selection_values,
        anomaly_type: 'proactive'
      });

      if (response.data) {
        setAlerts(response.data);
      }
    } catch (error) {
      console.error('Error fetching alerts:', error);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Initialize filter checkboxes
  const initializeChecked = () => {
    let extractedCheck = {};
    filterOptions.forEach((filterGroup) => {
      extractedCheck[`${filterGroup.id}-${filterGroup.filter_name}`] = {};
      filterGroup.filter_options.forEach((filter) => {
        extractedCheck[`${filterGroup.id}-${filterGroup.filter_name}`][
          `${filter.id}-${filter.name}`
        ] = false;
      });
    });
    setFilterChecked(extractedCheck);
  };

  const onFilterCheckboxChange = (checked) => {
    setFilterChecked(checked);
  };

  const onFilterCheckboxApply = () => {
    console.log('applying', filterChecked);
  };

  const onFilterCheckboxReset = () => {
    initializeChecked();
    console.log('resetting', filterChecked);
  };

  return (
    <WidgetTile
      title={'Alerts'}
      viewMoreRoute={'/alerts'}
      enableFilter={true}
      filterConfig={{
        type: 'checkbox',
        options: filterOptions,
        value: filterChecked,
        handleChange: (check) => onFilterCheckboxChange(check),
        handleApply: () => onFilterCheckboxApply(),
        handleReset: () => onFilterCheckboxReset()
      }}
      bodyContent={
        <div
          style={{
            overflowY: 'scroll',
            maxHeight: '550px',
            scrollbarWidth: 'none'
          }}
        >
          {loading ? (
            <p style={{ fontSize: '14px' }}>Loading alerts...</p>
          ) : alerts.length === 0 ? (
            <p style={{ fontSize: '14px' }}>No alerts found</p>
          ) : (
            alerts.map((alert, index) => (
              <div
                key={alert.anomaly_id || alert.id}
                style={{
                  padding: '12px 0',
                  borderBottom:
                    index + 1 !== alerts.length
                      ? '1.22px solid var(--primary-border-bottom-color)'
                      : 'none'
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px'
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}
                  >
                    <p
                      style={{
                        fontSize: '14px',
                        color: 'var(--black)',
                        textAlign: 'start',
                        margin: 0
                      }}
                    >
                      {alert.inference}
                    </p>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      gap: '30px'
                    }}
                  >
                    <p
                      style={{
                        fontSize: '12px',
                        color: 'var(--card-quaternary-color)',
                        margin: 0
                      }}
                    >
                      {new Date(alert.aan_date).toLocaleDateString()}
                    </p>
                    <AlertCriticalityCard status={alert.severity} />
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      }
    />
  );
};

// ✅ Reuse your filterOptions
const filterOptions = [
  {
    id: '1',
    filter_name: 'status',
    filter_display_name: 'Status',
    filter_options: [
      { id: '1', name: 'all', display_name: 'All', parent: true },
      { id: '1', name: 'high', display_name: 'High', child: true },
      { id: '2', name: 'medium', display_name: 'Medium', child: true },
      { id: '3', name: 'update', display_name: 'Update', child: true }
    ]
  }
];

export default WidgetAlerts;
